import { AlpineComponent } from 'alpinejs';
import Chart from 'chart.js/auto';
import ChartDeferred from 'chartjs-plugin-deferred';

const ChartPieComponent = (): AlpineComponent => ({
  init() {
    const SELECTOR_CHART_PIE_INIT = this.$root;
    

    // Add a resize event listener to the window
    // window.addEventListener('resize', () => {
    //     // If the window width is less than or equal to 768px (mobile)
    //     if (window.innerWidth <= 768) {
    //         // Set the canvas height to a value that suits your needs
    //         this.$root.style.height = '500px';
    //     } else {
    //         // Reset the canvas height for non-mobile devices
    //         this.$root.style.height = 'auto';
    //     }
    // });

    if (!SELECTOR_CHART_PIE_INIT) return;
    
    const CHART_PIE_DATA = JSON.parse(SELECTOR_CHART_PIE_INIT.getAttribute('data-data'));
    const CHART_PIE_LABELS = JSON.parse(SELECTOR_CHART_PIE_INIT.getAttribute('data-labels'));
    const CHART_PIE_COLORS = JSON.parse(SELECTOR_CHART_PIE_INIT.getAttribute('data-colors'));

    const CHART_PIE_DATA_INTEGER = CHART_PIE_DATA.map(el => Number(el));
    const data = CHART_PIE_DATA_INTEGER;

    const config = {
      plugins: [ChartDeferred,
        {
        id: "increase-legend-spacing",
        beforeInit(chart: any) {
          // Get reference to the original fit function
          const originalFit = (chart.legend as any).fit;
          // Override the fit function
          (chart.legend as any).fit = function fit() {
            // Call original function and bind scope in order to use `this` correctly inside it
            originalFit.bind(chart.legend)();

            // Calculate the new height based on the number of labels
            // 20 is the original height, 30 is the height for each label
            this.height += 20; //+ CHART_PIE_LABELS.length * 30;
          };
        }
      }
      ],
      type: 'pie',
      options: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          tooltip: {
            enabled: true
          },
          legend: {
            position: 'top',
            labels: {
              usePointStyle: true,
              padding: 20
            },
          },
          deferred: {
            yOffset: '100%',
            delay: 100
          }
        },
        animation: {
          duration: 850,
          easing: 'ease-out',
        },
        layout: {
          /* padding: {
            top: 10,
            bottom: 10
          }*/
        }
      },
      data: {
        labels: CHART_PIE_LABELS,
        datasets: [
          {
            data,
            backgroundColor: CHART_PIE_COLORS
          }
        ]
      }
    }

    new Chart(
      SELECTOR_CHART_PIE_INIT,
      config
    );
  }
});

export default ChartPieComponent;
